module.exports = __webpack_public_path__ + "static/media/file-search.9d29302e.svg";